import { GeneralModel } from "./general.model";
import { Province } from "./province.model";

export class District extends GeneralModel {
    provinceId: number;
    province:Province;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/district.model.ts